import { initRequest, sendFileToS3 } from './request.js';

const restApi = initRequest(process.env.BACKEND_API);

/**
 * @typedef {string} BucketUrl like https://bucket.s3.amazonaws.com/key
 */

/**
 * Upload file to share bucket
 *
 * @param {Object} params
 * @param {String} params.folderPath
 * @param {File} params.file
 * @returns {Promise<BucketUrl>}
 */
export async function uploadFile({ folderPath = '/', file }) {
  return restApi
    .post('/share-bucket/create-upload-access', {
      relativeFilePath: getRelativeFilePath(),
    })
    .then(({ result }) =>
      sendFileToS3(file, {
        s3key: result.fields.key,
        s3bucketUrl: result.url,
        s3fields: result.fields,
        defaultFileType: file.type,
      })
    );

  function getRelativeFilePath() {
    if (folderPath === '/') return `${file.name}`;
    let path = folderPath;
    if (path.startsWith('/')) path = path.slice(1);
    if (!path.endsWith('/')) path = `${folderPath}/`;
    return `${path}${file.name}`;
  }
}

export async function invalidateCache(paths = ['/*']) {
  return restApi.post('/share-bucket/invalidate-cache', { paths });
}
